module.exports = __webpack_public_path__ + "img/login-background.bd76fbe5.jpg";